import 'react-datepicker/dist/react-datepicker.css';

import React, { useEffect } from 'react';
import { Row, Col, Spinner, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { STATE_STATUS } from '@awp/constants';
import { overlayStyle, spinnerStyle } from '@components/Common/AwpStyles';
import ValidationForm from '@components/ManualDataValidation/ValidationForm';
import TableView from '@components/ManualDataValidation/TableView';
import { useMultiStationContext } from '@components/Graphs/MultiStation/MultiStationContext';
import { selectWeatherStation, fetchMultiStationData } from '@stores/dataVisualizationSlice';

const ManualDataValidationRenderer = () => {
  const { status, weatherStations, presetId, weatherStationId, dataRange } = useMultiStationContext();
  const loading = status.multiStationData === STATE_STATUS.LOADING;
  const dispatch = useDispatch();

  const weatherStation = useSelector(selectWeatherStation);

  useEffect(() => {
    if (loading) return;

    if (weatherStations?.length === 0 && weatherStationId == -1) return;
    if (!presetId) return;

    if (status.multiStationData === STATE_STATUS.LOADING || status.additionalMultiStationData === STATE_STATUS.LOADING)
      return;

    const fetchData = async () => {
      dispatch(
        fetchMultiStationData({
          weatherStationIds: [weatherStations[0].Id],
          weatherStationId,
          presetId,
          forceFetch: false,
          endDate: dataRange.endDate,
          displayRange: dataRange.displayRange,
        }),
      );
    };

    fetchData();
  }, [weatherStations, weatherStationId, presetId, dataRange]);

  return (
    <>
      {loading && (
        <>
          <div style={overlayStyle}></div>
          <div>
            <div className="text-center mt-4" style={spinnerStyle}>
              <p>Loading Data...</p>
              <Spinner animation="border" />
            </div>
          </div>
        </>
      )}
      <div style={{ position: 'relative', flex: '1' }} className="mt-3">
        <ValidationForm>
          {weatherStation && status.multiStationData == STATE_STATUS.SUCCESS && (
            <Row className="no-gutters">
              <Col style={{ zIndex: 1 }}>
                <Container fluid className="m-0 p-0">
                  <TableView />
                </Container>
              </Col>
            </Row>
          )}
        </ValidationForm>
      </div>
    </>
  );
};

export default ManualDataValidationRenderer;
